import carhartt from "../images/logocarhartt.jpg";
import doterra from "../images/doterra.jpeg";
import riders from "../images/riders.png";
import powell from "../images/powell-logo.jpg";
import magic from "../images/magic.png";
import maestra from "../images/maestra.jpeg";
import itt from "../images/itt.png";
import logoReact from "../images/logo-react-js.png";
import heart from "../images/heart.png";

export const listWorks = [
  {
    id: 1,
    img: carhartt,
    title: "Carhartt",
    description:
      "Carhartt es un ecommer de ventas de ropa para trabajo ubucada en distintas partes del mundo",
    position: "Trabaje como desarrollador Backend",
    url: "https://www.carhartt.com/es/es-es",
    mine: false,
  },
  {
    id: 11,
    img: doterra,
    title: "Doterra",
    description:
      "doTERRA.com es una plataforma integral para la compra y educación sobre aceites esenciales y productos relacionados. Fundada en 2008, doTERRA se dedica a proporcionar aceites esenciales de grado terapéutico puro, ofreciendo una amplia gama de productos, incluyendo aceites individuales, mezclas propietarias, productos para el cuidado personal, suplementos, y accesorios.",
    position: "Trabaje como desarrollador Full-Stack",
    url: "https://www.doterra.com/CA/en",
    mine: false,
  },
  {
    id: 2,
    img: powell,
    title: "Powell",
    description:
      "Powell es una empresa de Ecommerce dedicada a la venta de piezas electronicas",
    position: "Trabaje como desarrollador Full-Stack",
    url: "https://shop.powell.com/powellstorefront/?site=powell",
    mine: false,
  },
 
  {
    id: 5,
    img: maestra,
    title: "Maestra",
    description:
      "Agencia inmobiliaria con sede en Chile, especializada en la comercialización y arrendamiento de departamentos.",
    position: "Trabaje como desarrollador Full-Stack",
    url: "https://maestra.cl/",
    mine: false,
  },
  {
    id: 6,
    img: itt,
    title: "ITT",
    description:
      "ITT es una empresa minera dedicada a la venta de piezas de maquinarias pesadas",
    position: "Trabaje como desarrollador Full-Stack",
    url: "https://www.itt.com/home",
    mine: false,
  },
  {
    id: 7,
    img: riders,
    title: "Rider's Realm",
    description: "Trabajo hecho en React Remix",
    position: "",
    url: "https://riders-realm.netlify.app",
    mine: true,
  },
  {
    id: 8,
    img: riders,
    title: "Rider's Realm Backoffice",
    description: "Trabajo hecho en React Remix",
    position: "",
    url: "https://riders-realm-backoffice.netlify.app",
    mine: true,
  },
  {
    id: 9,
    img: logoReact,
    title: "Form React",
    description: "Proyecto Form con react ",
    position: "",
    url: "https://my-form-todo.netlify.app/",
    mine: true,
  },
  {
    id: 4,
    img: magic,
    title: "Socialad",
    description: "trabajo hecho en VueJs",
    position: "",
    url: "https://cranky-kirch-69ed95.netlify.app",
    mine: true,
  },
  {
    id: 12,
    img: logoReact,
    title: "Todo React",
    description: "Proyecto TODO con react ",
    position: "",
    url: "https://form-todo-react-vite.netlify.app/",
    mine: true,
  },
  {
    id: 13,
    img: heart,
    title: "Corazon CCS",
    description: "Proyecto diseño de corazon en CCS",
    position: "",
    url: "https://my-heart-1.netlify.app/",
    mine: true,
  },
  {
    id: 10,
    img: logoReact,
    title: "Login con React",
    description: "Trabajo hecho en React",
    position: "",
    url: "https://react2023-f9763.web.app/login",
    mine: true,
  },
 
];
